import React, { Fragment, useState } from 'react';
import { FaCloud, FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import DeleteTrainingMaterial from './deleteTrainingMaterial';
import EditTrainingMaterial from './editTrainingMaterial';
import { BiCloudDownload } from 'react-icons/bi';
import { exportFile } from 'utils/helpers';

const ViewDocument = ({ document, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr
        key={document?._id}
        className={`${index % 2 !== 0 && 'bg-gray-100'}`}
      >
        <TD>{index + 1}</TD>
        <TD>{document?.name}</TD>
        <TD>{document?.createdBy?.name}</TD>
        <TD>
          {document?.createdAt
            ? new Date(document?.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ''}
        </TD>
        <TD>{document?.type}</TD>
        <TD className={`text-left ${document.active ? " text-green-600" : "text-red-500"}`} >{document?.active ? "Yes": "No"}</TD>
        <TD>
          {checkPermission([permissions.create_training_material], currentUser) ? (
            <div className="items-center flex flex-row">
               <button
                onClick={() => {
                  document.documents?.map(item=>{
                    exportFile(item, document.name + "_training_material" )
                  })
                }}
                disabled= {!document.documents?.length}
                className={`items-center m-1 bg-yellow-500 bg-opacity-40 p-2 m-1 rounded-md   ${!document.documents?.length ? "text-gray-400" : "text-green-500"}`}
              >
                <BiCloudDownload className= "w-full" />
              </button>
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              {/* <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button> */}
              <button
                onClick={() => setShowDeleteModel(true)}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditTrainingMaterial
          data={document}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditTrainingMaterial
          data={document}
          handleClick={() => setShowEditModel(false)}
        />
      )}

      {showDeleteModel && (
        <DeleteTrainingMaterial
          id={document._id}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewDocument;
